/**
 * Brand constants - change these when rebranding
 */
export const BRANDING = {
  APP_NAME: 'MasterLapse',
  APP_TITLE: 'MasterLapse',
} as const;
